import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class LayoutService {

  readonly defaultShowLayoutState = true;

  showLayout: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.defaultShowLayoutState);

  constructor() { }

  resetShowLayout(): void {
    this.showLayout.next(this.defaultShowLayoutState);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/services/layout.service.ts